import { useContext, memo} from "react";
import { OrderContext } from "../../contexts/OrderContext";

const TotalPriceCell = ({ params }) => {
    const { orderState } = useContext(OrderContext);

    return ( 
    
    <div style={{ lineHeight: 1.4 }}>
        <div>{Number(orderState[params.row.id]?.total_price || 0).toFixed(2)} EUR</div>
        <div>{(Number(orderState[params.row.id]?.total_price || 0) * 1.95583).toFixed(2)} лв.</div>
    </div>)
}

export default memo(TotalPriceCell)